import { trpc } from '@tencent/tpro_rmonitor_alert_server_alert';
import { useAsyncEffect } from 'ahooks';
import { Card, Descriptions, List, Spin, Typography } from 'antd';
import { isEmpty } from 'lodash-es';
import React, { useState } from 'react';
import { formatKeyMethodsByLine } from '@/infrastructure/format-data';
import { getParamFromUrl } from '@/infrastructure/history';
import { alertService } from '@/service/alert';
import styles from './index.module.scss';
import IDetailReply = trpc.rmonitor.alert_server.IDetailReply;

const { Paragraph } = Typography;

export const AlertNotice = () => {
  const [alertInfo, setAlertInfo] = useState<IDetailReply | null>(null);
  const [loading, setLoading] = useState(false);
  const detailStack = alertInfo?.alertInfo?.detailStacks ?? [];

  const renderContent = (contentStr?: string) => {
    if (!contentStr) return null;
    try {
      const content = (contentStr.split('\n') || []).filter(item => !!item).map((item: string) => {
        const itemArr = item.split(': ');
        return {
          label: itemArr[0],
          value: itemArr[1],
        };
      });

      return content.map(item => <Descriptions.Item label={item.label}>{item.value || '-'}</Descriptions.Item>);
    } catch (e) {
      return null;
    }
  };

  const renderStackDetail = () => detailStack.map((item, index) => <List.Item key={index} style={{ wordBreak: 'break-word' }}>
        <div>{item?.stackTag}</div>
        <Paragraph
          ellipsis={{
            expandable: true,
            rows: 5,
          }}
        >{formatKeyMethodsByLine(item?.stack ?? '')}</Paragraph>
      </List.Item>);

  useAsyncEffect(async () => {
    setLoading(true);
    const res = await alertService.getAlertDetailBySessionID({
      sessionId: getParamFromUrl('sessionId'),
    });
    setAlertInfo(res);
    setLoading(false);
  }, []);

  return (
    <Spin spinning={loading}>
      <div className={styles.alertNotice}>
        <Card title={'告警通知'}>
          <Descriptions colon column={1}>
            <Descriptions.Item label={'产品'}>{alertInfo?.alertInfo?.productName}</Descriptions.Item>
            <Descriptions.Item label={'告警任务'}>{alertInfo?.alertInfo?.taskName ?? '-'}</Descriptions.Item>
            {renderContent(alertInfo?.alertInfo?.content ?? '')}
          </Descriptions>
          {!isEmpty(detailStack) && <List
            header={<div>崩溃详情</div>}
          >{renderStackDetail()}</List>}
        </Card>
      </div>
    </Spin>
  );
};
